import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { Card } from '@core/components/ui';

/**
 * ResponseErrorState Component
 *
 * Error state displayed when fetching response details fails.
 * Shows error icon and message in a centered card.
 *
 * @param {Object} props
 * @param {string} props.error - Error message to display
 */
export function ResponseErrorState({ error }) {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-zinc-50 p-4">
      <Card className="max-w-md w-full">
        <div className="text-center">
          <Icon icon="lucide:alert-circle" className="size-16 text-red-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-default mb-2">Error</h2>
          <p className="text-subtle">{error || 'Ha ocurrido un error. Por favor, intenta de nuevo.'}</p>
        </div>
      </Card>
    </div>
  );
}

ResponseErrorState.propTypes = {
  error: PropTypes.string,
};
